var czo = require("./142.js");
module.exports = function (czl, czm, czn, czs, czt) {
  var czu = new Error(czl);
  return czo(czu, czm, czn, czs, czt);
};